import { RootAppState } from 'store/configureStore'

export const projectIsExportingToErpSelector = (state: RootAppState) => {
  return state.project?.projectOperations?.isExportingToErp
}
